<script setup>
  import logo from '@/assets/logo.jpeg'
</script>

<template>
  <div class="app-wrapper">
    <header class="header">
      <div class="nav-container">
        <div class="brand">
          <img :src="logo" class="logo" alt="Logo" />
          <div class="brand-text">
            <h1>AYNURA <span class="accent">HOME</span></h1>
            <p>Premium Ev Tekstili</p>
          </div>
        </div>
        
        <nav class="minimal-nav">
          <router-link to="/">Anasayfa</router-link>
        </nav>
      </div>
    </header>

    <main class="main-content">
      <router-view />
    </main>

    <footer class="footer">
      <div class="footer-line"></div>
      <p>© 2026 Perde & Çeyiz — Modern Dokunuşlar</p>
    </footer>
  </div>
</template>

<style>
/* Reset & Global */
body {
  margin: 0;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif; /* Modern sans-serif */
  background: #ffffff; /* Pure white for a clean slate */
  color: #1a1a1a;
  -webkit-font-smoothing: antialiased;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Minimalist Header */
.header {
  background: #ffffff;
  padding: 30px 0;
  border-bottom: 1px solid #f0f0f0; /* Very light grey separator */
}

.nav-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  width: 60px; 
  height: auto;
  clip-path: circle();
  border: 50%;
}

.brand-text h1 {
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: 2px;
  margin: 0;
  color: #1a1a1a; /* Black */
}

.brand-text .accent {
  color: #2d5a27; /* Forest Green accent */
}

.brand-text p {
  margin: 0;
  font-size: 0.75rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #888; /* Grey subtext */
}

/* Subtle Navigation */
.minimal-nav {
  display: flex;
  align-items: center;
  gap: 15px;
}

.minimal-nav a {
  text-decoration: none;
  color: #1a1a1a;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.dot {
  width: 4px;
  height: 4px;
  background: #2d5a27;
  border-radius: 50%;
}

/* Footer */
.footer {
  padding: 60px 20px;
  text-align: center;
  background: #ffffff;
}

.footer-line {
  width: 50px;
  height: 1px;
  background: #2d5a27;
  margin: 0 auto 20px;
}

.footer p {
  color: #888;
  font-size: 0.8rem;
  letter-spacing: 1px;
}

/* Mobile Tweak */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 20px;
  }
  .header { padding: 20px 0; }
}
</style>